import { backendProtocol, backendHost, backendPort } from '../endpoints.js';
export const EVALUATION = backendProtocol + backendHost + backendPort + '/api/evaluation';

// Legacy endpoints (keeping for backward compatibility during transition)
export const SAVE_PROCUREMENT_PROCESS = EVALUATION + '/saveProcurementProcess'
export const FILTER_TENDERS = EVALUATION + '/filterProcurementProcesses';
export const GET_PROCUREMENT_PROCESS = EVALUATION + '/getProcurementProcess';
export const START_EVALUATION = EVALUATION + '/startEvaluation';
export const FILTER_PROCUREMENTS_WITHOUT_COMMITTEE = EVALUATION + '/filterProcurementsWithoutCommittee';
export const FILTER_COMMITTEES = EVALUATION + '/filterCommittees';
export const FILTER_MY_COMMITTEES = EVALUATION + '/filterMyCommittees';
export const SUBMIT_CONDUCT_DECISION = EVALUATION + '/submitCodeOfConductDecision';
export const SUBMIT_DECLARATION_DECISION = EVALUATION + '/submitDeclarationDecision';
export const SAVE_EVALUATIONS = EVALUATION + '/saveEvaluations';
export const FINALIZE_EVALUATION = EVALUATION + '/finalizeEvaluation';
export const FINALIZE_PRELIMINARY_EVALUATION = EVALUATION + '/finalizeEvaluation';
export const GET_BID_SECTION_SCORES = EVALUATION + '/getBidSectionScores';
export const GET_EVALUATION_OVERALL_PROGRESS = EVALUATION + '/getEvaluationOverallProgress';
export const SAVE_BID_SECTION_SCORES = EVALUATION + '/saveBidSectionScores';
export const CHECK_IS_CHAIR = EVALUATION + '/checkIsChair';
export const GET_COMMITTEE_STATUS = EVALUATION + '/getCommitteeProgress';
export const GET_COMMITTEE_CONSENSUS = EVALUATION + '/getCommitteeConsensus';
export const GET_CLARIFICATIONS = EVALUATION + '/getClarifications';
export const SAVE_CLARIFICATION = EVALUATION + '/saveClarification';
export const RESOLVE_EXPIRED_PRICE_CORRECTION = EVALUATION + '/resolveExpiredPriceCorrection';
export const SUBMIT_EVALUATED_SECTION = EVALUATION + '/submitEvaluatedSectionScores';
export const GET_SECTION_DETAILS = EVALUATION + '/getEvaluatorSectionsState';
export const GET_EVALUATORS_SECTIONS_PROGRESS = EVALUATION + '/getEvaluatorsSectionsScores'
export const GET_EVALUATORS_SECTION_CONSENSUS = EVALUATION + '/getEvaluatorSectionConsensus'
export const SUBMIT_CONSENSUS_DETAILS = EVALUATION + '/submitEvaluatedConsensusDetails';
export const SUBMIT_QCBS_TECHNICAL_THRESHOLD_LIST = EVALUATION + '/submitQCBSTechnicalThresholdList';
export const GET_QCBS_TECHNICAL_THRESHOLD_APPROVAL_STATUS = EVALUATION + '/getQCBSTechnicalThresholdApprovalStatus';
export const FETCH_QCBS_TECHNICAL_SHORTLIST = EVALUATION + '/fetchQCBSTechnicalShortlist';
export const APPROVE_QCBS_TECHNICAL_SHORTLIST = EVALUATION + '/approveQCBSTechnicalShortlist';
export const SAVE_FINANCIAL_DETAILS = EVALUATION + '/saveEvaluationFinancialDetails';
export const FETCH_FINANCIAL_DETAILS = EVALUATION + '/getEvaluationFinancialDetails';
export const GET_ALL_COMPLETED_FINANCIAL_DETAILS = EVALUATION + '/getAllEvaluationFinancialDetails'
export const FETCH_PROCUREMENT_AWARD_RECOMMENDATIONS = EVALUATION + '/getAwardRecommendations';
export const INITIATE_MPI_MPR_PROCESS = EVALUATION + '/initiateMarketPriceReasonableness'
export const SUBMIT_EVALUATION_REPORT_FOR_REVIEW = EVALUATION + '/submitEvaluationReportForReview'
export const INVITE_TO_NEGOTIATE_ENDPOINT = EVALUATION + '/inviteToNegotiate';
export const SEND_NEGOTIATION_MINUTES_ENDPOINT = EVALUATION + '/sendNegotiationMinutes';
export const SAVE_EVALUATION_REPORT_META_DATA = EVALUATION + '/saveEvaluationMetaData';
export const GET_EVALUATION_REPORT_META_DATA = EVALUATION + '/getEvaluationMetaData';
export const GENERATE_EVALUATION_REPORT = EVALUATION + '/generateEvaluationReport';
export const SIGN_EVALUATION_REPORT = EVALUATION + '/signEvaluationReport';
export const INITIATE_EVALUATION_APPROVALS = EVALUATION + '/initiateEvaluationApprovals';
export const SUBMIT_AWARD_DECISION = EVALUATION + '/submitAwardDecision';
export const APPROVE_AWARD_DECISION = EVALUATION + '/memberAwardApprovalDecision';
export const FETCH_APPROVALS_AWARD_STATUS = EVALUATION + '/fetchAwardApprovalStatus';
export const SEND_AWARD_NOTIFICATIONS = EVALUATION + '/sendAwardNotifications';
export const VIEW_AWARD_NOTICE = EVALUATION + '/generateBestAwardedBidderNotice';
export const FETCH_PROCUREMENT_ENTITY_STAND_STILL = EVALUATION + '/getAllProcurementEntityAwardDecisions';
export const GET_AWARD_DECISIONS_BY_PROCESS = EVALUATION + '/getAwardDecisions';
export const UPDATE_STANDSTILL_PERIOD = EVALUATION + '/updateStandStillPeriod';
export const COMPLETE_STANDSTILL_PERIOD = EVALUATION + '/completeStandStillPeriod';
export const CONFIRM_FUNDS = EVALUATION + '/confirmFunds';
export const INVITE_SUPPLIER_FOR_SIGNING = EVALUATION + '/inviteSupplierForSigning';
export const PUBLISH_EVALUATION_SHORTLIST = EVALUATION + '/publishShortlistAndSendInvitations';
export const FETCH_SHORTLISTED_SUPPLIERS = EVALUATION + '/fetchShortListSuppliers';
export const APPLY_FOR_SHORTLIST_WAIVER = EVALUATION + '/applyForShortlistWaiver';
export const GET_LOWEST_BID_PRICE = EVALUATION + '/getLowestBidPrice';
export const FETCH_SHAREHOLDERS = EVALUATION + '/fetchShareholders';
export const SAVE_MARKET_PRICE_ANALYSIS = EVALUATION + '/marketPriceAnalysis';
export const GET_SAVE_MARKET_PRICE_ANALYSIS = EVALUATION + '/getSavedMarketPriceAnalysis';
export const POST_QUALIFICATION_SCHEDULE = EVALUATION + '/postQualificationSchedule';
export const GET_POST_QUALIFICATION_SCHEDULE = EVALUATION + '/getPostQualificationSchedule';
export const POST_QUALIFICATION_RESULTS  = EVALUATION + '/postQualificationResults';
export const SUBMIT_RECOMMENDED_BIDDER_ENDPOINT = EVALUATION + '/submitRecommendedBidder'
export const SAVE_NEGOTIATION_OUTCOME = EVALUATION + '/saveNegotiationOutcome';
export const FINALIZE_NEGOTIATIONS = EVALUATION + '/finalizeNegotiation';
export const SAVE_DRAFT_CONTRACT_VERSION = EVALUATION + '/saveDraftContractVersion';
export const SUBMIT_CONTRACT_DRAFT = EVALUATION + '/submitDraftContract';
export const GET_CONTRACT_DRAFT_VERSIONS = EVALUATION + '/getContractVersions';
export const GET_LATEST_CONTRACT_DRAFT_VERSION = EVALUATION + '/getLatestDraftVersion';
export const SUBMIT_DRAFT_CONTRACT_REVIEW_DECISION = EVALUATION + '/submitDraftContractReviewDecision';
export const REJECT_DRAFT_CONTRACT = EVALUATION + '/rejectedDraftContract';
export const SEND_CONTRACT_MINUTES_ENDPOINT = EVALUATION + '/sendContractsMinutesForSigning';
export const DELETE_SUB_CONTRACTOR = EVALUATION + '/deleteSubContractor';
export const SUBMIT_FOR_CLEARANCE = EVALUATION + '/submitForClearance';
export const FINALIZE_CLEARED_CONTRACT = EVALUATION + '/finalizeClearedContract';
export const SHARE_CONTRACT_WITH_SUPPLIER = EVALUATION + '/shareContractWithSupplier';

//TENDERING
export const TENDER = backendProtocol + backendHost + backendPort + '/api/tender/';
export const ANALYZE_PRICE_REASONABLENESS = TENDER + 'analyzePriceReasonableness'
export const SEARCH_MPI_ITEMS = TENDER + 'searchMpiItems'

//REGISTRATION
export const REGISTRATION = backendProtocol + backendHost + backendPort + '/api/registration';
export const GET_ALL_SUPPLIERS = REGISTRATION + '/get-suppliers';

//FILE SERVICE END POINTS
export const FILE_SERVICE = backendProtocol + backendHost + backendPort + '/api/files/';
export const UPLOAD_FILE = FILE_SERVICE + 'upload-file';
export const GET_SUPPORTING_DOCUMENT = FILE_SERVICE + 'get';

// New ZPPA-compliant API endpoints following the instructions
export const NEW_API = {
  // Procurement Process & Committee Setup
  GET_PROCUREMENT_PROCESS: (procurementProcessId) => `${EVALUATION}/procurement-process/${procurementProcessId}`,
  GET_COMMITTEE: (procurementProcessId) => `${EVALUATION}/committee/procurement/${procurementProcessId}`,
  GET_CODE_OF_CONDUCT_STATUS: (committeeId) => `${EVALUATION}/committee/${committeeId}/conduct-status`,
  GET_CONFLICT_STATUS: (committeeId) => `${EVALUATION}/committee/${committeeId}/conflict-status`,
  
  // Bid Management
  GET_BIDS: (procurementProcessId) => `${EVALUATION}/bids/procurement/${procurementProcessId}`,
  
  // Evaluation Process
  START_EVALUATION: `${EVALUATION}/start`,
  GET_EVALUATION_SECTIONS: (procurementProcessId) => `${EVALUATION}/sections/${procurementProcessId}`,
  
  // Preliminary Evaluation
  SUBMIT_PRELIMINARY_EVALUATION: `${EVALUATION}/preliminary/evaluate`,
  GET_PRELIMINARY_SUMMARY: (evaluationId) => `${EVALUATION}/preliminary/summary/${evaluationId}`,
  
  // Technical Evaluation
  SUBMIT_TECHNICAL_EVALUATION: `${EVALUATION}/technical/evaluate`,
  GET_TECHNICAL_CONSENSUS: (evaluationId) => `${EVALUATION}/technical/consensus/${evaluationId}`,
  GET_INDIVIDUAL_TECHNICAL_SCORES: (evaluationId, bidId) => `${EVALUATION}/technical/individual-scores/${evaluationId}/${bidId}`,
  SUBMIT_TECHNICAL_CONSENSUS: `${EVALUATION}/technical/consensus`,
  
  // Commercial Evaluation
  SUBMIT_COMMERCIAL_EVALUATION: `${EVALUATION}/commercial/evaluate`,
  
  // Financial Evaluation
  SUBMIT_FINANCIAL_EVALUATION: `${EVALUATION}/financial/evaluate`,
  
  // Ranking & Results
  GENERATE_RANKING: `${EVALUATION}/ranking/generate`,
  
  // Post-qualification
  SUBMIT_POST_QUALIFICATION: `${EVALUATION}/post-qualification`,

  
  // Shortlisting (Expression of Interest)
  CREATE_SHORTLIST: `${EVALUATION}/award/shortlist`,
  GET_SHORTLIST: (procurementProcessId) => `${EVALUATION}/award/shortlist/${procurementProcessId}`,
  APPROVE_SHORTLIST: (shortlistId) => `${EVALUATION}/award/shortlist/${shortlistId}/approve`,
  PUBLISH_SHORTLIST: (shortlistId) => `${EVALUATION}/award/shortlist/${shortlistId}/publish`,
  
  // Appeals
  SUBMIT_APPEAL: `${EVALUATION}/appeals/submit`,
  GET_APPEALS: (procurementProcessId) => `${EVALUATION}/appeals/procurement/${procurementProcessId}`,
  
  // Additional utility endpoints
  GET_EVALUATION_STATUS: (evaluationId) => `${EVALUATION}/status/${evaluationId}`,
  UPDATE_EVALUATION_STAGE: (evaluationId) => `${EVALUATION}/stage/${evaluationId}`,
  SAVE_DRAFT_EVALUATION: `${EVALUATION}/draft/save`,
  GET_DRAFT_EVALUATION: (evaluationId, bidId, stage) => `${EVALUATION}/draft/${evaluationId}/${bidId}/${stage}`,
  
  // Consensus and collaboration
  REQUEST_CLARIFICATION: `${EVALUATION}/clarification/request`,
  RESPOND_TO_CLARIFICATION: (clarificationId) => `${EVALUATION}/clarification/${clarificationId}/respond`,
  GET_CONSENSUS_MEETINGS: (evaluationId) => `${EVALUATION}/consensus/meetings/${evaluationId}`,
  SCHEDULE_CONSENSUS_MEETING: `${EVALUATION}/consensus/meetings/schedule`,
  
  // Audit and compliance
  GET_EVALUATION_AUDIT_TRAIL: (evaluationId) => `${EVALUATION}/audit/${evaluationId}`,
  VALIDATE_ZPPA_COMPLIANCE: (procurementProcessId) => `${EVALUATION}/compliance/zppa/${procurementProcessId}`,
  
  // Notification endpoints
  SEND_COMMITTEE_NOTIFICATIONS: (committeeId) => `${EVALUATION}/notifications/committee/${committeeId}`,
  SEND_BIDDER_NOTIFICATIONS: (procurementProcessId) => `${EVALUATION}/notifications/bidders/${procurementProcessId}`,

  // Multi-Evaluator Progress Tracking
  GET_EVALUATOR_PROGRESS: (procurementProcessId, sectionId) => `${EVALUATION}/progress/${procurementProcessId}/${sectionId}`,
  GET_INDIVIDUAL_PROGRESS: (procurementProcessId, sectionId, evaluatorId) => `${EVALUATION}/progress/${procurementProcessId}/${sectionId}/${evaluatorId}`,
  UPDATE_EVALUATOR_PROGRESS: `${EVALUATION}/progress/update`,
  
  // Consensus Analysis and Detection
  ANALYZE_CONSENSUS: (procurementProcessId, sectionId) => `${EVALUATION}/consensus/analyze/${procurementProcessId}/${sectionId}`,
  GET_DETAILED_SCORES: (procurementProcessId, sectionId) => `${EVALUATION}/scores/detailed/${procurementProcessId}/${sectionId}`,
  
  // Section Finalization (Chair Only)
  CHECK_FINALIZATION_READINESS: (procurementProcessId, sectionId) => `${EVALUATION}/finalization/check/${procurementProcessId}/${sectionId}`,
  FINALIZE_SECTION: `${EVALUATION}/finalization/finalize`,
  
  // Evaluator Notifications and Management
  SEND_EVALUATOR_NOTIFICATION: `${EVALUATION}/notifications/evaluator`,
  GET_EVALUATOR_NOTIFICATIONS: (evaluatorId) => `${EVALUATION}/notifications/evaluator/${evaluatorId}`,
  MARK_NOTIFICATION_READ: (notificationId) => `${EVALUATION}/notifications/${notificationId}/read`,
  
  // Progress Reporting
  GENERATE_PROGRESS_REPORT: (procurementProcessId, sectionId) => `${EVALUATION}/reports/progress/${procurementProcessId}/${sectionId}`,
  GET_COMMITTEE_SUMMARY: (procurementProcessId) => `${EVALUATION}/reports/committee-summary/${procurementProcessId}`,
  
  // Real-time Updates and Synchronization
  GET_REAL_TIME_UPDATES: (procurementProcessId, sectionId) => `${EVALUATION}/realtime/updates/${procurementProcessId}/${sectionId}`,
  SUBSCRIBE_TO_UPDATES: (procurementProcessId, sectionId) => `${EVALUATION}/realtime/subscribe/${procurementProcessId}/${sectionId}`,
  
  // Consensus Meeting Management
  SCHEDULE_CONSENSUS_MEETING_DETAILED: `${EVALUATION}/consensus/meetings/schedule-detailed`,
  GET_MEETING_DETAILS: (meetingId) => `${EVALUATION}/consensus/meetings/${meetingId}`,
  UPDATE_MEETING_ATTENDANCE: (meetingId) => `${EVALUATION}/consensus/meetings/${meetingId}/attendance`,
  RECORD_MEETING_MINUTES: (meetingId) => `${EVALUATION}/consensus/meetings/${meetingId}/minutes`,
  
  // Chair-Specific Endpoints
  GET_CHAIR_DASHBOARD: (procurementProcessId) => `${EVALUATION}/chair/dashboard/${procurementProcessId}`,
  GET_EVALUATOR_COMPARISON: (procurementProcessId, sectionId) => `${EVALUATION}/chair/comparison/${procurementProcessId}/${sectionId}`,
  OVERRIDE_CONSENSUS: `${EVALUATION}/chair/consensus/override`,
};
